import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import { ThirdPartyAdapter } from '../thirdparty-adapter/index.esm.js';
import { getErrorMessage } from '../../../utils/get-error-message/index.esm.js';
import { initGoogleMapsApi } from '../../../utils/map-provider/google-api/index.esm.js';

/**
 * @deprecated This file is deprecated and should no longer be used or modified.
 * Please use shared UI adapters instead.
 */
/**
 * @deprecated
 */
const GOOGLEMAPS_CATEGORY = 'GOOGLEMAPS';
var PlacesServiceStatus;
(function (PlacesServiceStatus) {
  PlacesServiceStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
  PlacesServiceStatus["OK"] = "OK";
  PlacesServiceStatus["OVER_QUERY_LIMIT"] = "OVER_QUERY_LIMIT";
  PlacesServiceStatus["REQUEST_DENIED"] = "REQUEST_DENIED";
  PlacesServiceStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  PlacesServiceStatus["ZERO_RESULTS"] = "ZERO_RESULTS";
})(PlacesServiceStatus || (PlacesServiceStatus = {}));
/**
 * @deprecated
 */
class GoogleAdapter extends ThirdPartyAdapter {
  google;
  googleAutoCompleteService;
  placesService;
  ready;
  static instances = {};
  constructor(locale, apiKey, version) {
    super(locale);
    this.category = GOOGLEMAPS_CATEGORY;
    this.sourceName = 'GPA';
    this.type = 'ADDRESS';
    const conf = {
      accessToken: apiKey,
      locale,
      version
    };
    const timeoutDuration = 10000;
    const timeoutPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('Timeout: Map API initialization took too long'));
      }, timeoutDuration);
    });
    this.ready = Promise.race([initGoogleMapsApi(false, conf, false), timeoutPromise]).then(() => {
      this.google = window.google;
      this.initGooglePlacesService();
      return true;
    }).catch(err => {
      console.error(err);
      return false;
    });
  }
  static getInstance(locale, apiKey, version) {
    const thisLocale = locale || 'en_US';
    const thisGoogleApiKey = apiKey || (typeof window !== 'undefined' && typeof window.Cypress !== 'undefined' ? window.Cypress.env('GOOGLE_MAPS_API_KEY') : undefined) || '';
    if (!(thisLocale in this.instances)) {
      this.instances[thisLocale] = new GoogleAdapter(thisLocale, thisGoogleApiKey, version);
    }
    return this.instances[thisLocale];
  }
  isReady() {
    return this.ready;
  }
  initGooglePlacesService() {
    if (this.google && this.google.maps && this.google.maps.places) {
      const {
        AutocompleteService,
        PlacesService
      } = this.google.maps.places;
      this.googleAutoCompleteService = new AutocompleteService();
      this.placesService = new PlacesService(document.createElement('div'));
    }
  }
  fetchResults(essResponse) {
    const request = {
      input: essResponse.q,
      type: essResponse.rc === 'ADDRESS_AUTOCOMPLETE' ? ['geocode'] : undefined
    };
    const toEssResponse = results => ({
      q: essResponse.q,
      rc: essResponse.rc,
      rid: essResponse.rid,
      sr: results
    });
    return new Promise(resolve => {
      if (this.googleAutoCompleteService) {
        this.googleAutoCompleteService.getPlacePredictions(request, (predictions, status) => {
          if (status === PlacesServiceStatus.OK) {
            const response = toEssResponse(this.handleResponse(predictions));
            resolve(response);
          } else {
            resolve(essResponse);
          }
        });
      } else {
        resolve(essResponse);
      }
    });
  }
  fetchLocation(placeId) {
    return this.isReady().then(isReady => new Promise((resolve, reject) => {
      if (!isReady === false) {
        try {
          const request = {
            placeId,
            fields: ['geometry']
          };
          this.placesService.getDetails(request, (place, status) => {
            if (status === PlacesServiceStatus.OK) {
              const loc = place?.geometry?.location;
              if (loc) resolve({
                lat: loc.lat().toFixed(5),
                lng: loc.lng().toFixed(5)
              });else resolve(undefined);
            } else if (status === PlacesServiceStatus.ZERO_RESULTS) resolve(undefined);else reject(new Error(`Failed to fetch location for placeId ${placeId}: ${status}`));
          });
        } catch (error) {
          reject(new Error(`Failed to fetch location for placeId ${placeId}: ${getErrorMessage(error)}`));
        }
      } else {
        reject(new Error(`Unable to fetch location for placeId ${placeId}: PlacesService is not initialized`));
      }
    }));
  }
  handleResponse(predictions) {
    const results = [];
    predictions.forEach((prediction, index) => {
      results.push(this.toEssResult(prediction.description, prediction.place_id, index));
    });
    return results;
  }
}
export { GOOGLEMAPS_CATEGORY, GoogleAdapter, PlacesServiceStatus };